import Vue from 'vue';
export default Vue.extend({
    name: 'Hyperlink',
    functional: true,
    props: {
        variant: {
            type: String,
            default: 'primary',
        },
        href: {
            type: String,
            default: '',
        },
        to: {
            type: Object,
            default: () => null,
        },
        newTab: {
            type: Boolean,
            default: false,
        },
    },
    render(h, ctx) {
        const isRouterLink = ctx.props.to;
        const element = isRouterLink ? 'router-link' : 'a';
        const data = {
            ...ctx.data,
            class: { ...ctx.data.class, ...{ [`link-${ctx.props.variant}`]: true } },
            attrs: {
                ...ctx.data.attrs,
                target: ctx.props.newTab ? '_blank' : null,
                rel: ctx.props.newTab ? 'noopener' : null,
                ...(!isRouterLink
                    ? {
                        href: ctx.props.href,
                    }
                    : {}),
            },
            ...(isRouterLink
                ? {
                    props: {
                        to: ctx.props.to,
                    },
                }
                : {}),
        };
        return h(element, data, [ctx.slots().default]);
    },
});
